<main [style.width]="size == 'middle' ? '32px' : '20px'" [style.height]="size == 'middle' ? '32px' : '20px'"
  [style.border]="border == 'true' ? 'solid 3px #39693B' : 'none'"
  [style.font-size]="size == 'middle' ? '12px' : '10px'" [style.backgroundColor]="size == 'middle' ? '' : ''">

  @if(icon) {
  <span class="material-symbols-outlined" [style.backgroundColor]="''"
    [style.color]="size == 'middle' ? '' : '#FFFF'" [style.fontSize.px]="16" [style.borderRadius]="'50%'"
    [style.padding]="'4px'">person_2</span>
  } @else {
  <span [style.color]="size == 'middle' ? '' : '#FFFF'">{{iniciais}}</span>
  }
</main>
